import $ from 'jquery'

export default {
  // params: ['show'],
  inserted(el, binding) {
    const $el = $(el)
    const $c = $el.find($el.data('content-selector') || '[data-role=tooltip-content]')

    const config = binding.value || {}
    const mc = {}

    if ($c && $c.length > 0) {
      const $clone = $c.clone()
      $clone.show()
      mc.title = $clone.prop('outerHTML')
    }

    $el.tooltip(
      $.extend(
        {
          html: true,
          placement: 'right',
          trigger: 'hover'
        },
        config,
        mc
      )
    )

    $el.on('show.bs.tooltip', function() {
      // $c.show();
      // self.params.show = true;
    })

    $el.on('hidden.bs.tooltip', function() {
      // self.params.show = false;
    })

    /* $(document).on('click', function(e){
            var isOut = true;

            $(e.target).parents().addBack().each(function(){

                if(this == $el[0]) {
                    isOut = false;
                }
            });

            if(isOut) {
                $el.tooltip('hide');
                // po.inState.click = false;
            }
        }); */

    // $pc.on('click', '[data-role=close-tooltip]', function(){
    // $el.tooltip('hide');
    // po.inState.click = false;
    // })
  }
}
